module.exports = {
    methods: {
        $inDepartment (department) {
            return (this.$page.props.auth.user.departments || []).includes(department);
        },
        $role (role) {
            return (this.$page.props.auth.user.role || null) === role;
        },
    },
}
